import { render, staticRenderFns } from "./StartImport.vue?vue&type=template&id=449309d9&"
import script from "./StartImport.vue?vue&type=script&lang=js&"
export * from "./StartImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports